// extracted by mini-css-extract-plugin
export var dropdownButton = "_14-0";
export var fullWidthDropdownButton = "_14-1";
export var icon = "_14-3";
export var iconPlaceholder = "_14-2";
export var menuItemRow = "_14-8";
export var separator = "_14-c";
export var shortcutContainer = "_14-7";
export var shortcutIconLg = "_14-6";
export var shortcutIconMd = "_14-5";
export var shortcutIconSm = "_14-4";
export var submenuChevron = "_14-b";
export var submenuDropdown = "_14-9";
export var submenuTriggerRow = "_14-a";